import styled from "styled-components";

export const MenuMeses = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1vw;
    padding: 0.5vw 0;
    width: 100%;
    justify-content: stretch;
`